/**
 * 部署頁的「型態」分頁（批171 加 SaaS）：一筆部署只會落在一個桶。
 *
 * - `saas`＝多租戶平台旗下的組織（後端 `platform_id` 非 null，含已解除關聯的）；
 * - `managed`＝我方（或代理商）代管主機上的在役站台（`managed_host_id` 非 null）；
 * - `self`＝其餘＝客戶自己的機器。
 *
 * 平台組織先判：它沒有代管主機，舊版只看 `managed_host_id` 時會被誤歸成「自部署」。
 * 兩者實務上不會同時成立（平台組織的綁機錨點與代管站的 instance_id 是兩套），萬一同時成立以 SaaS 為準。
 */
import type { Deployment } from '@/api/ls'

export type DeploymentKind = 'saas' | 'managed' | 'self'

export function deploymentKind(d: Pick<Deployment, 'managed_host_id' | 'platform_id'>): DeploymentKind {
  if (d.platform_id) return 'saas'
  if (d.managed_host_id) return 'managed'
  return 'self'
}
